export default function HeatByHeatHome(){

  const allEvents = `https://data-aws.amaproracing.com/api/season/schedule/2024/XC`
  // const allEvents = `https://data-aws.amaproracing.com/api/season/schedule/2023/MX`
  // const allEvents = `https://data-aws.amaproracing.com/api/season/schedule/2023/SX`
  const hbhHomeContainer = $('#hbh-home-container')
  if( ! hbhHomeContainer.length ) { return; }

  const loaded = (target) => $(target).addClass('loaded')
  const sort = (source) => source.sort ((a,b) => new Date(b.EDate) - new Date(a.EDate))
  const Render = {
    events: function(source){
      let container = ``
      for ( let event of source ){
        const name = event.EventName
        const sanction = event.Sanction
        const location = `${event.City}, ${event.State}`
        const date = event.EDate
        container += `<div class="hbh-event">`
        container += `  <span class="hbh-event-title">${location}</span>`
        container += `  <span class="hbh-event-divider"></span>`
        container += `  <span class="hbh-event-location">${date}</span>`
        container += `  <a href="/event/${sanction}" class="hbh-event-btn btn btn-small btn-purple">event results</a>`
        container += `</div>`
      }
      hbhHomeContainer.html(container)
    }
  }

  $.ajax( {
    url: allEvents,
    method: 'GET',
    dataType: 'json',
    error: () => {
      console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
    },
    success: data => {
      Render.events(data)
      loaded('#hbh-home')
    }
  });


}